import { KeycloakProvider } from "./config/KeycloakContext.tsx";
import { Layout } from "./components/Layout";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import SearchPage from "./pages/SearchPage";
import FlowPage from "./pages/FlowPage";
import DocumentDetailsPage from "./pages/DocumentDetailsPage";
import FreezeResultsPage from "./pages/FreezeResultsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import SettingsPage from "./pages/SettingsPage";
import { UserProvider } from "./config/UserContext";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { useEffect } from "react";
import { trackEvent } from "./config/logrocket";
import { useKeycloak } from "./config/KeycloakContext";
import { SessionTimeoutModal } from "./components/SessionTimeoutModal";

// Component to track route changes only when authenticated
function RouteTracker() {
  const location = useLocation();
  const { keycloak, initialized } = useKeycloak();
  
  useEffect(() => {
    // Only track navigation when user is authenticated
    if (initialized && keycloak && keycloak.authenticated) {
      trackEvent('Navigation', {
        pathname: location.pathname,
        search: location.search,
        hash: location.hash,
      }).catch(error => {
        console.warn('Failed to track navigation event:', error);
      });
    }
  }, [location, initialized, keycloak]);
  
  return null;
}

function App() {
  const hostname = window.location.hostname;
  const isKioskMode = hostname.startsWith('kiosk');

  return (
    <ErrorBoundary>
      <Router>
        <Routes>
          {/* Protected Application Routes */}
          <Route path="/*" element={
            <KeycloakProvider>
              <UserProvider>
                <RouteTracker />
                <SessionTimeoutModal isKioskMode={isKioskMode} />
                <Layout>
                  <Routes>
                    {/* Always redirect root to search since marketing site is external */}
                    <Route path="/" element={<Navigate to="/search" replace />} />
                    <Route path="/search" element={<SearchPage />} />
                    <Route path="/document/:documentId/details" element={<DocumentDetailsPage />} />
                    <Route path="/document/:documentId/:step" element={<FlowPage />} />
                    <Route path="/freeze/:freezeId/simple-flow/:documentId/:step" element={<FlowPage />} />
                    <Route path="/freeze/:freezeId" element={<FreezeResultsPage />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                    <Route path="/settings" element={<SettingsPage />} />
                  </Routes>
                </Layout>
              </UserProvider>
            </KeycloakProvider>
          } />
        </Routes>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
